import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { Toaster } from "@/components/ui/sonner";
import SolicitorRequest from "@/pages/SolicitorRequest";
import Login from "@/pages/Login";
import ContractorDashboard from "@/pages/ContractorDashboard";
import InvoiceGenerator from "@/pages/InvoiceGenerator";
import InvoiceHistory from "@/pages/InvoiceHistory";
import InvoiceView from "@/pages/InvoiceView";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<SolicitorRequest />} />
            <Route path="/login" element={<Login />} />
            <Route
              path="/contractor"
              element={
                <ProtectedRoute>
                  <ContractorDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/contractor/invoices"
              element={
                <ProtectedRoute>
                  <InvoiceHistory />
                </ProtectedRoute>
              }
            />
            <Route
              path="/contractor/invoices/:id"
              element={
                <ProtectedRoute>
                  <InvoiceView />
                </ProtectedRoute>
              }
            />
            <Route
              path="/contractor/invoice/:jobId"
              element={
                <ProtectedRoute>
                  <InvoiceGenerator />
                </ProtectedRoute>
              }
            />
          </Routes>
          <Toaster />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
